import React from 'react';
import { v as bvVar } from 'bv';

import NavigationButtonContainer from './navigation_button_container';

const NavigationButtons = () => (
  <div className="floating-nav__list">
    {bvVar('floatingNavButtons').map((button) => (
      <NavigationButtonContainer key={button.id} {...button} />
    ))}
  </div>
);

export default NavigationButtons;
